export const PAGE_MAX_WIDTH_CLASS = 'w-full max-w-[1920px]'
export const SIDEBAR_WIDTH_CLASS = 'md:w-[33.33%] md:min-w-[33.33%] lg:w-[25%] lg:min-w-[25%] xl:w-[20%] xl:min-w-[20%]'
export const DESKTOP_NAV_SIDEBAR_CLASS =
  'hidden md:flex md:basis-1/3 lg:basis-1/4 xl:basis-1/5  flex-col h-full overflow-auto bg-bgLight md:sticky md:top-0 md:left-0 md:bottom-0'
export const DESKTOP_MAIN_CONTENT_CLASS =
  'w-full bg-white md:basis-2/3 lg:basis-3/4 xl:basis-3/5 flex flex-col overflow-auto min-h-min'
export const DESKTOP_SIDEBAR_CLASS = 'hidden xl:flex xl:basis-1/5 bg-bglight'
export const AUTHENTICATED_LAYOUT_COLUMNS_WIDTH_CLASS =
  'md:grid-cols-[33.33%_1fr] lg:grid-cols-[25%_1fr] 2xl:grid-cols-[16.66%_1fr]'
export const CONTENT_COLUM_NEGATIVE_MARGIN_CLASS = 'md:-mx-[25px]'
export const NAVBAR_HEIGHT_CLASS = 'max-md:h-[calc(64px+env(safe-area-inset-bottom))]'

export const TAILWIND_BREAKPOINTS = {
  xs: 1,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
  '3xl': 1920,
}

export const TAILWIND_CONFIG = {
  theme: {
    // Explicitly defining the default screens so that they can be accessed in React
    screens: {
      xs: `${TAILWIND_BREAKPOINTS.xs.toString()}px`,
      // => @media (min-width: 1px) { ... }

      sm: `${TAILWIND_BREAKPOINTS.sm.toString()}px`,
      // => @media (min-width: 640px) { ... }

      md: `${TAILWIND_BREAKPOINTS.md.toString()}px`,
      // => @media (min-width: 768px) { ... }

      lg: `${TAILWIND_BREAKPOINTS.lg.toString()}px`,
      // => @media (min-width: 1024px) { ... }

      xl: `${TAILWIND_BREAKPOINTS.xl.toString()}px`,
      // => @media (min-width: 1280px) { ... }

      '2xl': `${TAILWIND_BREAKPOINTS['2xl'].toString()}px`,
      // => @media (min-width: 1536px) { ... }

      '3xl': `${TAILWIND_BREAKPOINTS['3xl'].toString()}px`,
      // => @media (min-width: 1920px) { ... }
    },
    extend: {
      animation: { loadingBar: 'loading 2s ease-in infinite' },
      keyframes: { loadingBar: { '0%': { backgroundPosition: '200% 0%' }, '100%': { backgroundPosition: '0% 0%' } } },
      backgroundImage: {
        'image-gradient-page-header': 'linear-gradient(30deg, #27272A 5%,#18181B 97%)',
      },
      fontFamily: {
        'open-sans': ['Open Sans'],
        noto: ['var(--font-noto)'],
      },
      fontSize: {
        xs: '0.75rem',
        sm: '0.875rem',
        base: '1rem',
        lg: '1.125rem',
        xl: '1.25rem',
        '2xl': '1.5rem',
        '3xl': '1.875rem',
        '4xl': '2.25rem',
        '5xl': '3rem',
        '6xl': '3.75rem',
        '7xl': '4.5rem',
        '8xl': '6rem',
        '9xl': '8rem',
      },
      borderRadius: {
        4: '4px',
      },
      colors: {
        alert: {
          500: '#C82320',
          300: '#FB5653',
          100: '#FFEAEA',
        },
        bgSuccess: '#E9FFF0',
        textSuccess: '#10642b',
        meta: '#4a5565',
        iconmuted: '#B6B9B7',
        iconfull: '#0E0E0E',
        header: '#0E0E0E',
        body: '#444846',
        light: '#eeefee',
        bglight: '#F9FAF9',
        action: '#2679B6',
        // Moved Color Scales to Design System as part of migration away from this file.
        // ALERTS
        alertErrorTitle: '#c82320',
        alertErrorText: '#641210',
        alertErrorToastText: '#641210',
        alertErrorIconFill: '#fb5653',
        alertErrorBg: '#fef2f2',
        alertErrorCloseBtnFill: '#fc807e',

        alertSuccessTitle: '#10642b',
        alertSuccessText: '#047857',
        alertSuccessToastText: '#062417',
        alertSuccessIconFill: '#34d399',
        alertSuccessBg: '#e9fff0',
        alertSuccessCloseBtnFill: '#899f96',

        alertInfoTitle: '#174a6f',
        alertInfoText: '#174a6f',
        alertInfoIconFill: '#2679b6',
        alertInfoBg: '#ebf6ff',
        alertInfoCloseBtnFill: '#174a6f',

        alertInfoSecondaryTitle: '#6c28d9',
        alertInfoSecondaryText: '#6c28d9',
        alertInfoSecondaryIconFill: '#8a5cf6',
        alertInfoSecondaryBg: '#f5f3ff',
        alertInfoSecondaryCloseBtnFill: '#6c28d9',

        alertWarningTitle: '#964713',
        alertWarningText: '#964713',
        alertWarningIconFill: '#fb924d',
        alertWarningBg: '#fff1e9',
        alertWarningCloseBtnFill: '#964713',

        // BORDER
        borderDark: '#D8D9D8',

        // BUTTONS
        // Primary Button - Background
        btnPrimaryBg: '#0E0E0E',
        btnPrimaryBgDisabled: '#D8D9D8',
        btnPrimaryBgActive: '#3B3E3C',
        btnPrimaryBgHover: '#3B3E3C',

        btnPrimaryInvertedBg: '#F9FAF9',
        btnPrimaryInvertedBgDisabled: '#F9FAF9',
        btnPrimaryInvertedBgActive: '#EEEFEE',
        btnPrimaryInvertedBgHover: '#FFFFFF',

        // Primary Button - Text
        btnPrimaryText: '#EEEFEE',
        btnPrimaryTextDisabled: '#575B58',
        btnPrimaryTextActive: '#FFFFFF',
        btnPrimaryTextHover: '#FFFFFF',

        btnPrimaryInvertedText: '#3B3E3C',
        btnPrimaryInvertedTextDisabled: '#949895',
        btnPrimaryInvertedTextActive: '#3B3E3C',
        btnPrimaryInvertedTextHover: '#0E0E0E',

        // Secondary Button - Background
        btnSecondaryBg: '#00000000', // transparent
        btnSecondaryBgDisabled: '#00000000', // transparent
        btnSecondaryBgActive: '#EEEFEE',
        btnSecondaryBgHover: '#00000000', // transparent

        btnSecondaryInvertedBg: '#00000000', // transparent
        btnSecondaryInvertedBgDisabled: '#00000000', // transparent
        btnSecondaryInvertedBgActive: '#ffffff1a',
        btnSecondaryInvertedBgHover: '#ffffff1a',

        // Secondary Button - Text
        btnSecondaryText: '#202220',
        btnSecondaryTextDisabled: '#949895',
        btnSecondaryTextActive: '#3B3E3C',
        btnSecondaryTextHover: '#202220',

        btnSecondaryInvertedText: '#FFFFFF',
        btnSecondaryInvertedTextDisabled: '#949895',
        btnSecondaryInvertedTextActive: '#D8D9D8',
        btnSecondaryInvertedTextHover: '#FFFFFF',

        // Secondary Border - Border
        btnSecondaryBorder: '#D8D9D8',
        btnSecondaryBorderDisabled: '#D8D9D8',
        btnSecondaryBorderActive: '#EEEFEE', // transparent
        btnSecondaryBorderHover: '#575B58',

        btnSecondaryInvertedBorder: '#D8D9D8',
        btnSecondaryInvertedBorderDisabled: '#B6B9B7',
        btnSecondaryInvertedBorderActive: '#00000000', // transparent
        btnSecondaryInvertedBorderHover: '#FFFFFF',

        // Destruction Button - Background
        btnDestructionBg: '#C82320',
        btnDestructionBgDisabled: '#D8D9D8',
        btnDestructionBgActive: '#961A18',
        btnDestructionBgHover: '#FA2C28',

        // Destruction Button - Text
        btnDestructionText: '#EEEFEE',
        btnDestructionTextDisabled: '#575B58',
        btnDestructionTextActive: '#FFFFFF',
        btnDestructionTextHover: '#FFFFFF',

        // Link Button - Text
        btnLinkText: '#2679B6',
        btnLinkTextDisabled: '#949895',
        btnLinkTextActive: '#2679B6',
        btnLinkTextHover: '#35A8FD',
      },
      spacing: {
        '3xs': '0.5rem',
        '2xs': '1rem',
        xs: '1.5rem',
        sm: '2rem',
        md: '2.5rem',
        lg: '3rem',
        xl: '3.5rem',
        '2xl': '4rem',
        '3xl': '4.5rem',
        '4xl': '5rem',
        '5xl': '6rem',
        '6xl': '8rem',
      },
    },
    debugScreens: {
      position: ['bottom', 'right'],
    },
  },
  corePlugins: {
    aspectRatio: false,
  },
  plugins: [import('@tailwindcss/aspect-ratio'), import('@tailwindcss/forms')],
}
